import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { motion } from "framer-motion";
const CommunitySubmission = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><span className="w-2 h-2 bg-[#DF6D2A] rounded-full animate-pulse" /><span className="font-body text-[11px] tracking-[0.25em] uppercase text-[#DF6D2A]">Community Archiving</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-display text-[32px] sm:text-[40px] md:text-[44px] lg:text-[60px] leading-[1] text-[#F4EFE6] mb-5 sm:mb-6 md:mb-8">Help Us Preserve <br /><em className="text-[#C9A84C] italic">The Untold Stories</em></h2>;
    t2 = <p className="font-body text-[14px] sm:text-[16px] text-white/60 leading-[1.7] sm:leading-[1.8] font-light mb-7 sm:mb-8 md:mb-10 max-w-[500px]">Do you have ancestral photographs, personal diaries, ship manifests, or unrecorded oral histories? Contribute to the Global Girmitiya Digital Archive. Your family's legacy is a vital piece of world history.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-full lg:w-[50%] z-10">{t0}{t1}{t2}<div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-6"><Link href="/contact" className="font-body px-6 sm:px-8 py-3.5 sm:py-4 btn-primary text-[11px] sm:text-[12px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-white hover:text-[#0F1C2E] transition-colors duration-300 text-center">Submit an Artifact</Link><Link href="/about" className="font-body px-6 sm:px-8 py-3.5 sm:py-4 border border-white/20 text-[#F4EFE6] text-[11px] sm:text-[12px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-white/5 transition-colors duration-300 text-center">Read Curatorial Guidelines</Link></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      scale: 0.9
    };
    t5 = {
      opacity: 1,
      scale: 1
    };
    t6 = {
      once: true
    };
    t7 = {
      duration: 1
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute inset-4 border border-[#DF6D2A]/30 transform rotate-3 transition-transform duration-700 hover:rotate-0" />;
    t9 = <img src="https://images.unsplash.com/photo-1594122230689-45899d9e6f69?q=80&w=1000&auto=format&fit=crop" alt="Handwritten diary and personal archive submitted by the community" className="w-full h-full object-cover grayscale-[50%] sepia-[30%]" />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32 relative border-t border-[#C9A84C]/20 overflow-hidden"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12"><div className="flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-16 items-center">{t3}<div className="w-full lg:w-[50%] relative flex justify-center"><motion.div initial={t4} whileInView={t5} viewport={t6} transition={t7} className="relative w-[90%] sm:w-[80%] lg:w-[80%] aspect-square border border-[#C9A84C]/20 p-3 sm:p-4">{t8}{t9}<div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-[#F4EFE6] p-3 sm:p-4 border border-[#0F1C2E]/20 shadow-xl"><p className="font-body text-[9px] sm:text-[10px] uppercase tracking-widest text-[#4C596B]">Last Donation</p><p className="font-display text-[16px] sm:text-[20px] text-[#0F1C2E]">Awaadi Diary (1902)</p></div></motion.div></div></div></div></section>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
export default CommunitySubmission;